import { UnaMapRequest } from '../../una-routes';
import * as KlipApi from '@/api/klip-api.proxy';
import * as UnaModel from '../../shared/una-model';
import KlSearchMaprequests from '@/app/shared/components/kl-search-maprequests/kl-search-maprequests.vue';
import {
    castStringToSearchField,
    MapRequestSearchField
} from '@/app/shared/components/kl-search-maprequests/kl-search-maprequests';
import { escape } from 'html-escaper';
import {computed, defineComponent, onBeforeMount, onMounted, reactive, ref, useTemplateRef, watch} from 'vue';
import DateUtil from '@/app/shared/helpers/date-util';
import {useUnaStore} from '@/app/una/una-store';
import {IFilterData, IMapRequestMeta} from '@/app/una/maprequest-store-context';
import {isEmpty} from 'lodash-es';

export default defineComponent({
    name: 'KlUnaToReply',
    emits: ['update-query'],
    setup(props, { emit }) {

        const searchMaprequests = useTemplateRef<InstanceType<typeof KlSearchMaprequests>>('searchMaprequests');

        const unaStore = useUnaStore();
        const toReply = computed(() => unaStore.toReply);

        const selectedZone_AllOption = 'all';
        const searchUsed = ref<boolean>(false);

        const mapRequests = computed((): UnaModel.IMapRequestListItem[] => toReply.value.mapRequests);
        const mapRequestsColumns = computed((): KlipApi.IColumn[] => toReply.value.mapRequestsColumns);
        const mapRequestsFetching = computed((): boolean => toReply.value.mapRequestsFetching);
        const mapRequestsMeta = computed((): IMapRequestMeta => toReply.value.mapRequestsMeta);

        const mapRequestDefaultFilter = computed((): MapRequestSearchField => {
            return _apiInputToFilter(toReply.value.filterData.defaultSearchFilter);
        });

        const maprequestCurrentFilter = computed((): MapRequestSearchField => {
            return _apiInputToFilter(toReply.value.mapRequestsInput);
        });

        const selectedZone = computed({
            get (): string {
                return toReply.value.mapRequestsInput?.utilityNetworkAuthorityZoneId || selectedZone_AllOption;
            },
            set (newZoneId: string){
                toReply.value.updateFilter(_applySelectedZoneToInput(toReply.value.mapRequestsInput, newZoneId));
            }
        })

        const filterData = computed((): IFilterData<KlipApi.IGetMapRequestsToReplyInput> => toReply.value.filterData);
        const mapRequestsHasZones = computed(() => !isEmpty(filterData.value.zones));

        const pagerClicked = (page: number) => {
            toReply.value.updatePagination(page);
        };

        const columnClicked = (column: KlipApi.IColumn) => {
            toReply.value.updateSorting(column);
        };

        function _apiInputToFilter(input: KlipApi.IGetMapRequestsToReplyInput): MapRequestSearchField {
            if (!input) {
                return null;
            }
            return {
                searchField: input.searchField ? KlipApi.SearchField[input.searchField] : null,
                organisationId: input.organisationId,
                searchOption: input.organisationId || KlipApi.SearchOption.All.toString(),
                keyword: input.query || '',
                date: {
                    from: DateUtil.parseToDate(input.startDate),
                    to: DateUtil.parseToDate(input.endDate),
                },
            };
        }

        function _filterToApi(searchFields: MapRequestSearchField): KlipApi.IGetMapRequestsToReplyInput {
            console.assert(searchFields, 'Invalid argument: searchFields is required');
            return {
                query: searchFields.keyword,
                organisationId: searchFields.organisationId, //searchFields.searchOption === KlipApi.SearchOption.All.toString() ? null : searchFields.searchOption,
                searchOption: !searchFields.organisationId ? KlipApi.SearchOption.All : KlipApi.SearchOption.SubOrganisation, // castStringToSearchOption(searchFields.searchOption, KlipApi.SearchOption.SubOrganisation) as any,
                searchField: castStringToSearchField(searchFields.searchField),
                startDate: DateUtil.formatForApi(searchFields.date.from, 'ISO'),
                endDate: DateUtil.formatForApi(searchFields.date.to, 'ISO'),
            }
        }

        const _parseCell = (row: IRow, column: IColumn) => {
            if (!row[column.key]) {
                return '';
            }

            const cellValue = escape(row[column.key])
            return {
                template: row.mapRequestId && row.unaZoneId
                    ? `<kl-router-link :to='${JSON.stringify(UnaMapRequest)}' :params='{id:"${row.mapRequestId}", archived:"false", zoneId:"${row.unaZoneId}"}'>${cellValue}</kl-router-link>`
                    : `<span>${cellValue}</span>`,
            };
        }

        onBeforeMount(async () => {
            await useUnaStore().initToReply(_parseCell);
        });


        const search = (searchFields: MapRequestSearchField) => {
            searchUsed.value = true;

            toReply.value.updateFilter(_applyFilterToInput(toReply.value.mapRequestsInput, searchFields));
        }

        const _applyFilterToInput = (input: KlipApi.IGetMapRequestsToReplyInput, searchFields: MapRequestSearchField): KlipApi.IGetMapRequestsToReplyInput => {
            const newInput = _filterToApi(searchFields);
            return {
                ...input,
                ...newInput,
            };
        }

        const _applySelectedZoneToInput = (input: KlipApi.IGetMapRequestsToReplyInput, zoneId: string): KlipApi.IGetMapRequestsToReplyInput => {
            const utilityNetworkAuthorityZoneId = zoneId === selectedZone_AllOption ? null : zoneId;
            return {
                ...input,
                utilityNetworkAuthorityZoneId,
            };
        }

        const clearSearch = () => {
            searchMaprequests.value.reset();
            selectedZone.value = null;
        }

        return {
            mapRequests,
            searchUsed,
            mapRequestsMeta,
            mapRequestsColumns,
            mapRequestsFetching,
            selectedZone,

            pagerClicked,
            columnClicked,
            search,
            clearSearch,

            filterData,
            mapRequestsHasZones,
            mapRequestDefaultFilter,
            maprequestCurrentFilter,
        };

    }
})
